<template>
	<div class="checkbox">
		<div class="wrapper">
			<input 
			:checked="checked" 
			:name="name"
			:disabled="disabled" 
			type="radio">
		</div> <span class="text">{{ text }}</span>
	</div>
</template>

<style lang="scss" scoped>
	.checkbox {
		position: relative;
		padding-left: 25px;

		.wrapper {
			position: absolute;
			left: 0;
		}
	}
</style>

<script>
		
	import bus from '@/bus/event-bus.js'

	export default {
		props: ['value', 'text', 'name', 'checked', 'disabled', 'pergunta'],

		data() {
			return {
				check: {}
			}
		},

		watch: {
			disabled() {
				if(!this.disabled) {
					this.check.iCheck('enable')
				} else {
					this.check.iCheck('disable')
				}
			}
		},

		mounted() {
			this.check = $(this.$el).find("input");

			this.check.iCheck({
				radioClass: 'iradio-pink'
			})

			$(this.$el).find(".text").click(() => {
				if(!this.disabled) {
					this.check.iCheck('check')
				}
			})

			this.check.on('ifChecked', () => {
				if(!this.disabled) {
					var perguntaId = null

					if(this.pergunta !== undefined) {
						perguntaId = this.pergunta.Id
					}

					this.$emit('checked', this.value, perguntaId)
				}
			})


		}
	}
</script>


// WEBPACK FOOTER //
// src/components/ui/Radio.vue